module.exports = __webpack_public_path__ + "img/ss_home copy.fddab4f0.png";